import React, { Component } from 'react';
import Paragraphs from 'components/common/Paragraphs';
import { getVHInPixel } from 'utils/VHChecker';
import { default as SM } from 'scrollmonitor';
import throttle from 'lodash/throttle';
import './Description.css';

class Description extends Component {
	constructor(props) {
		super(props);
		this.wrap_el = React.createRef();
		this.desc_el = React.createRef();
		this.monitoring = false;
	}
	componentDidMount() {
		window.addEventListener('resize', this.throttledResize);
		this.recalc();
		requestAnimationFrame( () => { this.recalc() } );
	}
	componentDidUpdate(prevProps, prevState) {
		this.recalc();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.throttledResize);
		this.throttledResize.cancel();
		this.destroyScrollMonitor();
	}
	recalc = () => {
		if ( window.innerWidth >= 769 ) {
			if ( !this.monitoring ) { 
				this.wrap_el.current.classList.add('monitoring');
				this.updateWrapperHeight();
				this.setupScrollMonitor();
			} else { 
				this.updateWrapperHeight();
				this.updateScrollMonitor();
			}
		} else {
			if ( this.monitoring ) {
				this.destroyScrollMonitor();
				this.wrap_el.current.classList.remove('monitoring');
				this.wrap_el.current.removeAttribute('style');
				this.desc_el.current.removeAttribute('style');
			}
		}
	}
	throttledResize = throttle( this.recalc, 100 )
	setupScrollMonitor = () => {
		this.monitoring = true;
		this.sm = SM.create( this.wrap_el.current, { top: this.getYTrigger()} );
		this.sm.on('stateChange', this.setFixStatus);
		this.setFixStatus();
	}
	updateScrollMonitor = () => {
		this.sm.offsets.top = this.getYTrigger();
		this.sm.recalculateLocation();
		this.setFixStatus();
	}
	destroyScrollMonitor = () => {
		this.monitoring = false;
		if (this.sm) { this.sm.destroy(); this.sm = null; }
	}
	updateWrapperHeight = () => {
		const desc_h = this.desc_el.current.clientHeight;
		this.wrap_el.current.style.height = desc_h + 'px';
	}
	getYTrigger() {
		const viewport_h = getVHInPixel(100);
		const desc_h = this.desc_el.current.clientHeight;
		const h_diff = viewport_h - desc_h;
		const offsetTop = (h_diff > 0)? Math.round(h_diff*0.5) : 0;
		const maxOffsetTop = this.desc_el.current.offsetTop;
		return Math.min( maxOffsetTop, offsetTop );
	}
	setFixStatus = () => {
		const position = this.sm.isAboveViewport ? 'fixed' : 'absolute';
		const top = (this.sm.isAboveViewport)
			? this.getYTrigger()
			: this.sm.top + this.sm.offsets.top;
		
		this.desc_el.current.removeAttribute('style');
		this.desc_el.current.style.position = position;
		this.desc_el.current.style.top = top + 'px';
	}

	render() {
		return (
			<div className="Project-description-wrap" ref={this.wrap_el}>
				<div className="Project-description" ref={this.desc_el}>
					<div className="wrap">
						<div className="Project-description-inner">
							<Paragraphs text={this.props.text} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Description;


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Parts/Description.jsx